var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"}},[_c('path',{attrs:{"d":"M7 13L1 7L7 1","stroke":"black","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }